import { MAIN_STYLE, MAIN_STYLE_GROUPS, PADDING_SIDES, PRESS_EVENTS } from '../shared.js'
// TODO: Parts and Styles lvgl7 linemeter
// The Line meter has only a main part, called LV_LINEMETER_PART_MAIN. 
// It uses all the typical background properties the draw a rectangle-like or circle background and the line and scale properties to draw the scale lines. 
// The active lines (which are related to smaller values the the current value) are colored from line_color to scale_grad_color. 
// The lines in the end (after the current value) are set to scale_end_color color.

export const linemeter = {

    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            propertyGroups: [...MAIN_STYLE_GROUPS],
            properties: {
                ...MAIN_STYLE,
                line_color:       { type: 'color' },
                line_width:       { type: 'int', min: 0 },
                scale_grad_color: { type: 'color' },
                // Visually significant in lv_linemeter_draw_scale (tick-mark thickness,
                // color of ticks past the current value) — real theme defaults below
                // (lv_theme_hasp.c:573-579).
                scale_width:            { type: 'int', min: 0 },
                scale_end_color:        { type: 'color' },
                scale_end_line_width:   { type: 'int', min: 0, label: 'scale end line width' },
                // Lower priority — theme leaves both at 0 by default.
                scale_border_width:     { type: 'int', min: 0, label: 'scale border width' },
                scale_end_border_width: { type: 'int', min: 0, label: 'scale end border width' },
                padding:          { type: 'int', min: 0, exportSpecial: true },
                ...PADDING_SIDES,
                keep_circle:      { type: 'bool', internal: true },
            },
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        haspid:   { type: 'int', min: 1, max: 254, internal: true },
        parentid: { type: 'int', min: 0, max: 254, internal: true },
        enabled: { type: 'bool' }, hidden: { type: 'bool' },
        val:        { type: 'int' }, min: { type: 'int' }, max: { type: 'int' },
        angle:      { type: 'int', min: 0, max: 360, unit: '°', hasp: true },
        rotation:   { type: 'int', min: 0, max: 360, unit: '°', hasp: true },
        type:       { type: 'int', min: 0, max: 1 },
        line_count: { type: 'int', min: 0 },
        value_str:  { type: 'string' },
        value_font: { type: 'int', min: 8 },
        // Value Font Family selection — same VALUE_FONT-slot convention as
        // gauge.js/arc.js's identically-named property (see gauge.js's comment
        // for the full wire-format semantics). Falls back to the hardcoded
        // 'Material Icons' family when unset, same as those widgets.
        value_font_resource: { type: 'resource', resourceType: 'font', label: 'Value Font Family', inline: true },
        value_color:{ type: 'color' },
        value_ofs_x:{ type: 'int', label: 'value offset x' },
        value_ofs_y:{ type: 'int', label: 'value offset y' },
        // Read directly as this.theme.tick_color (see HaspLineMeter.js) rather
        // than through the Style API — it has no LVGL wire-key equivalent, it's
        // a theme-only visual default for the non-indicator tick marks.
        tick_color:   { type: 'color', internal: true },
        stretch_mode: {
            type: 'string', internal: true, default: 'keep_ratio',
            options: ['none', 'keep_ratio', 'v_stretch', 'h_stretch', 'full'],
        },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 100, height: 100, min_width: 40, min_height: 10,
            enabled: true, hidden: false,
            min: 0, max: 100, val: 0, value_str: '',
            type: 0, rotation: 0, angle: 240, line_count: 18,
            value_font_resource: '',
        },
        styles: {
            // Real theme (lv_theme_hasp.c:573-579): pad_hor=20, pad_top=20 (pad_bottom is
            // never set by the theme at all — inherent LVGL asymmetry,
            // lv_linemeter_draw_scale never reads it), line_width=10.
            main: {
                padding: 15, line_width: 10,
                scale_width: 25, scale_end_color: '#888888', scale_end_line_width: 7,
            },
        },
    },
    states: ['pressed', 'disabled'],
    editorCapabilities:  ['can_transform', 'can_copy', 'has_objectmenu', 'keep_ratio'],
    runtimeCapabilities: ['has_data'],

    events: PRESS_EVENTS,
    bindings: {
        properties: { val: {}, min: {}, max: {}, value_str: {} },
        actions: { hass_services: [] },
        events: {},
    },
}
